<div class="selectIssueContainer" [ngClass]="{'is-mobile-view': isMobileView}">
    <div class="selectIssueHeader">
        <span class="selectIssueTitle" [ngClass]="{'is-mobile-view': isMobileView}">{{'makeMoov.selectIssue' | gender  | translate }} {{counterpartDetails.firstName}}? </span>
        <!-- <span class="selectIssueSubTitle">{{'makeMoov.selectIssueOption' | gender | translate }} </span> -->
    </div>
    <div class="formContainer">
        <form #issuesForm="ngForm">
            <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedIssue" name="selectedIssue">
                <div class="issuesContainer" [ngClass]="{'is-mobile-view': isMobileView}">
                    <div class="issueContainer" *ngFor="let issue of issues" [ngClass]="{'is-mobile-view': isMobileView}">
                        <mat-radio-button  class="issueRadioCotnainer" value="{{issue.id}}" (change)="issueSelected(issue)"><span class="issueLabel"> {{issue.name}}</span></mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </form>
    </div>
    <button mat-button class="missingIssueButton" (click)="sendFeedback()" >{{this.isMale? ('makeMoov.missingIssue.MALE' | translate) : ('makeMoov.missingIssue.FEMALE' | translate)}}</button>
</div>